$.extend(true, orion, {
    api: {
        bonusitem: {}
    }
});

var
    api = orion.api.bonusitem,
    uri = '/api-bonusitem';

function read()
{
    var
        promise = $.ajax(uri, {
            'method': 'GET'
        });

    return promise;
}

api.read = read;
